import { version } from '../../package.json'

let requestURL = ''
switch (process.env['REACT_APP_CHANNEL']) {
  case 'haiou':
    requestURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'http://api.wsgold.com.cn:8443' : 'http://api.bl.dev.seedtecgz.com'
    break
  case 'qxtj':
  case 'qxyg':
  case 'qxdg':
    requestURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'https://api.hnjcwlkj.cn' : 'http://api.dev.hnjcwlkj.cn'
    break
  case 'tjyg':
    requestURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'https://yg.api.hrbgjs.com' : 'http://api.dev.hnjcwlkj.cn'
    break
  case 'tradeasy':
    requestURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'https://api.hnqcwlkj.com' : 'http://apit.dev.jltxjh.cn'
    break
  case 'trading':
    requestURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'http://nm.api.seedtecgz.com' : 'http://nm.api.seedtecgz.com'
    break
  case 'ytyg':
    requestURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'http://api.dev.yt.hnytysjs.com' : 'http://api.dev.yt.hnytysjs.com'
    break
  default:
    // xiniu & xibei & wanshun & youpin & dyyg
    requestURL = process.env['REACT_APP_BUILD_ENV'] === 'production' ? 'https://api.hnqcwlkj.com' : 'http://api.dev.hnqcwlkj.com'
}

const appInfo = {
  version,
  requestURL,
  channel: process.env['REACT_APP_CHANNEL'],
  buildEnv: process.env['REACT_APP_BUILD_ENV'],
  nodeEnv: process.env['NODE_ENV'],
  lang: process.env['REACT_APP_LANG'],
}

export default appInfo
